import React from 'react';
import './Hero.css';

export default function Hero() {
  const handleScrollToBook = () => {
    const el = document.getElementById('book');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="hero">
      {/* organic blob gradients */}
      <span className="hero__blob hero__blob--1" aria-hidden="true" />
      <span className="hero__blob hero__blob--2" aria-hidden="true" />
      <span className="hero__blob hero__blob--3" aria-hidden="true" />

      <div className="hero__stage">
        <div className="hero__eyebrow mono">
          <span className="hero__dot" />
          <span>Salon · TRUSSVILLE</span>
          <span className="hero__dash" />
          <span>Est. 2016</span>
        </div>

        <h1 className="hero__name display">
          <span className="hero__row">
            <span className="hero__word">Bella</span>
          </span>
          <span className="hero__row">
            <span className="hero__seven">7</span>
          </span>
        </h1>

        <p className="hero__tagline">
          A quiet salon for <em>haircuts, color, and bridal moments.</em>
          <br />
          Slow, considered, and entirely yours.
        </p>

        <button
          type="button"
          className="hero__cta"
          onClick={handleScrollToBook}
          aria-label="Scroll to booking section"
        >
          <span>Reserve a chair</span>
          <span className="hero__cta-arrow" aria-hidden="true">↓</span>
        </button>
      </div>

      <div className="hero__meta">
        <div>
          <div className="hero__meta-label mono">Hours</div>
          <div className="hero__meta-value display">Mon–Fri · 9–4</div>
        </div>
        <div>
          <div className="hero__meta-label mono">Studio</div>
          <div className="hero__meta-value display">106 Kays Ave, Trussville, AL</div>
        </div>
        <div>
          <div className="hero__meta-label mono">Booking</div>
          <div className="hero__meta-value hero__meta-value--small">
            Online (Now Available)
          </div>
        </div>
        <div>
          <div className="hero__meta-label mono">Care</div>
          <div className="hero__meta-value hero__meta-value--small">
            Hair · Color · Bridal
          </div>
        </div>
      </div>

      <div className="hero__scroll-cue" aria-hidden="true">
        <span className="mono">scroll</span>
        <span className="hero__scroll-line" />
      </div>
    </div>
  );
}